// @flow
import type { ERROR_TYPE, ID_TYPE } from './common';

export type GATEWAY_TYPE = {
  id: number,
  name: string,
  ordinal: string,
  gate: number,
  allow_exit: boolean,
  allow_change_requests: boolean,
  allow_entrance: boolean,
  user_count: number,
};

export type GATEWAYS_FETCH_STARTED_TYPE = {
  type: 'GATEWAYS_FETCH_STARTED',
  payload?: number,
};
export const GATEWAYS_FETCH_STARTED = 'GATEWAYS_FETCH_STARTED';

export type GATEWAYS_FETCH_SUCCESS_TYPE = {
    type: 'GATEWAYS_FETCH_SUCCESS',
    payload: {
        entities: {[number]: GATEWAY_TYPE},
        order: Array<number>,
        page?: number,
        next?: number,
        count?: number
    },
};
export const GATEWAYS_FETCH_SUCCESS = 'GATEWAYS_FETCH_SUCCESS';

export type GATEWAY_FETCH_SUCCESS_TYPE = {
  type: 'GATEWAY_FETCH_SUCCESS',
  payload: GATEWAY_TYPE
};
export const GATEWAY_FETCH_SUCCESS = 'GATEWAY_FETCH_SUCCESS';

export type GATEWAYS_FETCH_FAILED_TYPE = {
    type: 'GATEWAYS_FETCH_FAILED',
    payload: ERROR_TYPE
};
export const GATEWAYS_FETCH_FAILED = 'GATEWAYS_FETCH_FAILED';

export type GATEWAY_CREATE_STARTED_TYPE = {
  type: 'GATEWAY_CREATE_STARTED',
  payload: GATEWAY_TYPE
};

export const GATEWAY_CREATE_STARTED = 'GATEWAY_CREATE_STARTED';

export type GATEWAY_CREATE_SUCCESS_TYPE = {
  type: 'GATEWAY_CREATE_SUCCESS',
  payload: GATEWAY_TYPE
};

export const GATEWAY_CREATE_SUCCESS = 'GATEWAY_CREATE_SUCCESS';

export type GATEWAY_CREATE_FAILED_TYPE = {
  type: 'GATEWAY_CREATE_FAILED',
  payload: ERROR_TYPE
};

export const GATEWAY_CREATE_FAILED = 'GATEWAY_CREATE_FAILED';

// REMOVE gateways
export type REMOVE_GATEWAY_STARTED_TYPE = {
  type: 'REMOVE_GATEWAY_STARTED',
  payload: number
};
export const REMOVE_GATEWAY_STARTED = 'REMOVE_GATEWAY_STARTED';

export type REMOVE_GATEWAY_SUCCEED_TYPE = {
  type: 'REMOVE_GATEWAY_SUCCEED',
  payload: number
};
export const REMOVE_GATEWAY_SUCCEED = 'REMOVE_GATEWAY_SUCCEED';

export type REMOVE_GATEWAY_FAILED_TYPE = {
  type: 'REMOVE_GATEWAY_FAILED',
  payload: ERROR_TYPE
};
export const REMOVE_GATEWAY_FAILED = 'REMOVE_GATEWAY_FAILED';

export type GATEWAY_USERS_FETCH_STARTED_TYPE = {
  type: 'GATEWAY_USERS_FETCH_STARTED',
  payload: {
    id: number,
    filters: Object,
  }
};
export const GATEWAY_USERS_FETCH_STARTED = 'GATEWAY_USERS_FETCH_STARTED';

export type GATEWAY_USERS_FETCH_SUCCESS_TYPE = {
  type: 'GATEWAY_USERS_FETCH_SUCCESS',
  payload: {
    id: number,
    users: Array<number>
  }
};
export const GATEWAY_USERS_FETCH_SUCCESS = 'GATEWAY_USERS_FETCH_SUCCESS';

export type GATEWAYS_USERS_FETCH_FAILED_TYPE = {
  type: 'GATEWAYS_USERS_FETCH_FAILED',
  payload: ERROR_TYPE
};
export const GATEWAYS_USERS_FETCH_FAILED = 'GATEWAYS_USERS_FETCH_FAILED';

export type UPDATE_GATEWAY_USERS_PAGE_TYPE = {
  type: 'UPDATE_GATEWAY_USERS_PAGE',
  payload: {
    id: number,
    page: number,
  }
};
export const UPDATE_GATEWAY_USERS_PAGE = 'UPDATE_GATEWAY_USERS_PAGE';

export type ADD_GATEWAY_USER_STARTED_TYPE = {
  type: 'ADD_GATEWAY_USER_STARTED',
  payload: {
    id: number,
    user: number,
  }
};
export const ADD_GATEWAY_USER_STARTED = 'ADD_GATEWAY_USER_STARTED';

export type ADD_GATEWAY_USER_SUCCESS_TYPE = {
  type: 'ADD_GATEWAY_USER_SUCCESS',
  payload: {
    id: number,
    users: Array<number>,
  }
};
export const ADD_GATEWAY_USER_SUCCESS = 'ADD_GATEWAY_USER_SUCCESS';

export type ADD_GATEWAY_USER_FAILED_TYPE = {
  type: 'ADD_GATEWAY_USER_FAILED',
  payload: ERROR_TYPE
};
export const ADD_GATEWAY_USER_FAILED = 'ADD_GATEWAY_USER_FAILED';

export type REMOVE_GATEWAY_USER_STARTED_TYPE = {
  type: 'REMOVE_GATEWAY_USER_STARTED',
  payload: {
    id: number,
    user: number,
  }
};
export const REMOVE_GATEWAY_USER_STARTED = 'REMOVE_GATEWAY_USER_STARTED';

export type REMOVE_GATEWAY_USER_SUCCESS_TYPE = {
  type: 'REMOVE_GATEWAY_USER_SUCCESS',
  payload: {
    id: number,
    users: Array<number>,
  }
};
export const REMOVE_GATEWAY_USER_SUCCESS = 'REMOVE_GATEWAY_USER_SUCCESS';

export type REMOVE_GATEWAY_USER_FAILED_TYPE = {
  type: 'REMOVE_GATEWAY_USER_FAILED',
  payload: ERROR_TYPE
};
export const REMOVE_GATEWAY_USER_FAILED = 'REMOVE_GATEWAY_USER_FAILED';

export type GATEWAY_SELECTED_TYPE = {
  type: 'GATEWAY_SELECTED',
  payload: ID_TYPE,
};
export const GATEWAY_SELECTED = 'GATEWAY_SELECTED';

export type UPDATE_GATEWAY_ACTION_STARTED_TYPE = {
  type: 'UPDATE_GATEWAY_ACTION_STARTED',
  payload: Object
};
export const UPDATE_GATEWAY_ACTION_STARTED = 'UPDATE_GATEWAY_ACTION_STARTED';

export type UPDATE_GATEWAY_ACTION_FAILED_TYPE = {
  type: 'UPDATE_GATEWAY_ACTION_FAILED',
  payload: ERROR_TYPE,
}
export const UPDATE_GATEWAY_ACTION_FAILED = 'UPDATE_GATEWAY_ACTION_FAILED';


export type UPDATE_GATEWAY_ACTION_SUCCEDED_TYPE = {
  type: 'UPDATE_GATEWAY_ACTION_SUCCEDED',
  payload: Object,
}
export const UPDATE_GATEWAY_ACTION_SUCCEDED = 'UPDATE_GATEWAY_ACTION_SUCCEDED';


export type UPDATE_GATEWAY_STARTED_TYPE = {
  type: 'UPDATE_GATEWAY_STARTED',
  payload: Object
};
export const UPDATE_GATEWAY_STARTED = 'UPDATE_GATEWAY_STARTED';

export type UPDATE_GATEWAY_FAILED_TYPE = {
  type: 'UPDATE_GATEWAY_FAILED',
  payload: ERROR_TYPE,
}
export const UPDATE_GATEWAY_FAILED = 'UPDATE_GATEWAY_FAILED';


export type UPDATE_GATEWAY_SUCCEDED_TYPE = {
  type: 'UPDATE_GATEWAY_SUCCEDED',
  payload: GATEWAY_TYPE,
}
export const UPDATE_GATEWAY_SUCCEDED = 'UPDATE_GATEWAY_SUCCEDED';

export type UPDATE_GATEWAY_USERS_SUCCEED_TYPE = {
  type: 'UPDATE_GATEWAY_USERS_SUCCEED',
  payload: {
    id: number,
    users: Array<Object>,
  }
};
export const UPDATE_GATEWAY_USERS_SUCCEED = 'UPDATE_GATEWAY_USERS_SUCCEED';


export type GATEWAYS_ACTION_TYPE =
  | GATEWAYS_FETCH_STARTED_TYPE
  | GATEWAY_USERS_FETCH_STARTED_TYPE
  | REMOVE_GATEWAY_STARTED_TYPE
  | REMOVE_GATEWAY_FAILED_TYPE
  | REMOVE_GATEWAY_SUCCEED_TYPE
  | REMOVE_GATEWAY_USER_FAILED_TYPE
  | REMOVE_GATEWAY_USER_SUCCESS_TYPE
  | REMOVE_GATEWAY_USER_STARTED_TYPE
  | ADD_GATEWAY_USER_FAILED_TYPE
  | ADD_GATEWAY_USER_SUCCESS_TYPE
  | ADD_GATEWAY_USER_STARTED_TYPE
  | GATEWAYS_USERS_FETCH_FAILED_TYPE
  | UPDATE_GATEWAY_USERS_PAGE_TYPE
  | GATEWAY_USERS_FETCH_SUCCESS_TYPE
  | GATEWAY_FETCH_SUCCESS_TYPE
  | GATEWAYS_FETCH_FAILED_TYPE
  | GATEWAYS_FETCH_SUCCESS_TYPE
  | GATEWAY_SELECTED_TYPE
  | UPDATE_GATEWAY_ACTION_STARTED_TYPE
  | UPDATE_GATEWAY_ACTION_SUCCEDED_TYPE
  | UPDATE_GATEWAY_ACTION_FAILED_TYPE
  | UPDATE_GATEWAY_STARTED_TYPE
  | UPDATE_GATEWAY_SUCCEDED_TYPE
  | UPDATE_GATEWAY_FAILED_TYPE
  | UPDATE_GATEWAY_USERS_SUCCEED_TYPE;



// WEBPACK FOOTER //
// ./src/scripts/types/gateways.js